import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class GorbeaScore extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "userId", Model.attribute('userId'));
    _defineProperty(this, "seasonId", Model.attribute('seasonId'));
    _defineProperty(this, "scoreClassification", Model.attribute('scoreClassification'));
    _defineProperty(this, "scoreGoleadorLiga", Model.attribute('scoreGoleadorLiga'));
    _defineProperty(this, "scoreGoleadorTotal", Model.attribute('scoreGoleadorTotal'));
    _defineProperty(this, "scoreAsistenteLiga", Model.attribute('scoreAsistenteLiga'));
    _defineProperty(this, "scoreAsistenteTotal", Model.attribute('scoreAsistenteTotal'));
    _defineProperty(this, "scoreCopa", Model.attribute('scoreCopa'));
    _defineProperty(this, "scorePorteriasCero", Model.attribute('scorePorteriasCero'));
    _defineProperty(this, "scoreGoleadasFavor", Model.attribute('scoreGoleadasFavor'));
    _defineProperty(this, "scoreGoleadasContra", Model.attribute('scoreGoleadasContra'));
    _defineProperty(this, "totalScore", Model.attribute('totalScore'));
    _defineProperty(this, "breakdown", Model.attribute('breakdown'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "user", Model.hasOne('user'));
    _defineProperty(this, "season", Model.hasOne('season'));
  }
  apiEndpoint() {
    return '/nagusi/match-ratings/gorbea-scores' + (this.exists ? '/' + this.data.id : '');
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/GorbeaScore', GorbeaScore);